module.exports = __webpack_public_path__ + "abc36db2faa1734d0c4807e656a2700f.png";